module.exports = __webpack_public_path__ + "img/battletrip_section1.611b1bc1.jpg";